var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationBulb(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3164,
    cy: 19,
    r: 19,
    fill: "#FEF4D1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1584 10.2913L9.07422 11.3754L11.3743 13.6755L12.4584 12.5913L10.1584 10.2913Z",
    fill: "#F5CC3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.583 7H18.0498V10.0668H19.583V7Z",
    fill: "#F5CC3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3832 17.7332H7.31641V19.2665H10.3832V17.7332Z",
    fill: "#F5CC3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3163 17.7332H27.2495V19.2665H30.3163V17.7332Z",
    fill: "#F5CC3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8412 16.9199L24.8257 16.8121C24.3987 13.8215 21.8374 11.6 18.8163 11.6C15.7953 11.6 13.2339 13.8215 12.8067 16.8121L12.7912 16.9199C12.5471 18.6288 13.0361 20.2563 14.0016 21.5038C14.5895 22.2634 14.9828 22.9881 14.9828 23.7155V26.1667C14.9828 26.5902 15.3261 26.9335 15.7496 26.9335H21.8828C22.3063 26.9335 22.6496 26.5902 22.6496 26.1667V23.7152C22.6496 22.9879 23.0429 22.2631 23.6308 21.5035C24.5965 20.2563 25.0853 18.6288 24.8412 16.9199Z",
    fill: "#F5CC3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1166 28.4667H16.5166V30H21.1166V28.4667Z",
    fill: "#F5CC3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4744 10.2914L25.1743 12.5914L26.2587 13.6758L28.5587 11.3757L27.4744 10.2914Z",
    fill: "#F5CC3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(7.31641 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBulb);
export default __webpack_public_path__ + "static/media/notification_bulb.0bd5f6e0648131ea8204f71d8f69d809.svg";
export { ForwardRef as ReactComponent };